import { Carousel, Slide } from 'vue-carousel'
import appHeader from '../../components/header/header'
import appContact from '../../components/contact/contact'
import appFooter from '../../components/footer/footer'
import collage from '../../components/collage/collage'

export default {
    name: 'home',
    data() {
        return {
            animation: null,
            cards: [
                {active: true},
                {active: false},
                {active: true},
                {active: false}
            ]
        }
    },
    components: {
        appHeader,
        appContact,
        appFooter,
        collage,
        Carousel,
        Slide
    },
    methods: {
        updateActiveImage: function(toActive, toInactive) {
            this.cards[toActive].active = true;
            this.cards[toInactive].active = false;
        }
    }
}
